import { render, staticRenderFns } from "./AccountAchievements.vue?vue&type=template&id=05815107&"
import script from "./AccountAchievements.vue?vue&type=script&lang=js&"
export * from "./AccountAchievements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports